
import { HasConfirmationOfDeleting } from "../abstracts/mixins/HasConfirmationOfDeleting";
import { CRUDEntity } from "../abstracts/CRUDEntity";
import { FormActions } from "../abstracts/mixins/FormActions";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { Validator, ValidationError } from "../../snippets/Validator";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import { takeScreenshot, checkIfBrowserSupported } from "@xata.io/screenshot";
import Errors from '../../errors.js';
import { SaveButton } from "../../components/SaveButton.js";

export default class HelpTicket extends CRUDEntity {

    #validation_fields = [
        'subject',
        'details'
    ]

    constructor(id=null) {

        Object.assign(HelpTicket.prototype, FormActions);
        Object.assign(HelpTicket.prototype, HasConfirmationOfDeleting);
        Object.assign(HelpTicket.prototype, HasAttachments);
        Object.assign(HelpTicket.prototype, EntityModalForm);

        super();
        this.setAttachmentCallbackDelete()
        this.entityClass = 'help_ticket';
        this.isAdmin = window.location.pathname.indexOf('admin')>=0
        this.isCustomer = window.location.pathname.indexOf('customer')>=0 && !window.location.pathname.indexOf('cab');
        this.urlRoot = this.isAdmin ? '/admin/ticket-management/incident' : (this.isCustomer ? '/customer/help-ticket' :'/help-ticket');
        this.sectionRootUrl = this.isAdmin ? '/admin/ticket-management' : (this.isCustomer ? '/customer/help-ticket' :'/help-ticket');
        this.id = id;
        this.isPrepareFiles = true;


        document.addEventListener("load_modal", (event) => {
            $('#help-modal').modal('hide');
            $('input[disabled], select[disabled], textarea[disabled], .form-control[disabled]').css('background', '');
            this.initScreenShotListener();
        });

        HelpTicket.prototype.update = function(successCallback=this.callbackCloseModal, errorCallback=()=>{}, method='POST') {
            const formId = `edit-${this.entityClass}`;
            const data = this.collectDataInForm(formId);
            const SaveBtn = new SaveButton();
            let addParams = {}
            if(data instanceof FormData){
                addParams={
                    processData: false,
                    contentType: false,
                    cache: false,
                }
            }
            $.ajax({
                url: `${this.urlRoot}/${this.id}/update`,
                method: method,
                data: data,
                ...addParams,
                beforeSend: () => {
                    SaveBtn.startLoading();
                },
                success: (response) => {
                    this.id = response.id;
                    if(this.dropzone) {
                        this.dropzone.updateConfig({url: this.attachmentUrl()});
                        this.dropzone.dispatchOwnerCreated();
                    }
                    SaveBtn.stopLoading(true).then(() => {
                        SaveBtn.showSuccess()
                        .then(()=>successCallback(response))
                        .then(result => {
                            if(result) setTimeout(() => window.location.reload(), 500)
                        });
                    })
                },
                error: (response) => {
                    SaveBtn.stopLoading().then( () => {
                        SaveBtn.showError().then(() => {
                            errorCallback(response)
                        })
                    })
                }
            })
        }

        HelpTicket.prototype.collectDataInForm = function(formId){
            let data = new FormData();
            let inputs = $(`#${formId} input:not([type=checkbox]), #${formId} textarea, #${formId} select`);
            for (let input of inputs) {
                input = $(input);
                data.append(input.attr('name'), input.val())
            }
            if (this.prepareFiles instanceof FormData) {
                for (const [key, file] of this.prepareFiles.entries()) {
                    data.append(key, file);
                }
            }
            return data;
        }

        HelpTicket.prototype.delegatedListnersForButtons = function(type, entityClass) {
            const validateCb = () => {
                if(this.validationForm(type))
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',false)
                else
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',true)
            }
            for(let field of this.#validation_fields){
                $(`#${type}-${entityClass} [name=${field}]`).on('input',validateCb)
            }

            $(`#${type}-${entityClass} button#${type}`).off();
            $(`#${type}-${entityClass} button#${type}`).on('click', (e) => {
                e.preventDefault();
                if(this.validationForm(type,true)){
                    if(console.everything){
                        let str = this.stringify(console.everything);
                        $(`#${type}-${entityClass} #logs`).val(str);
                    }
                    const successCallback = this.isAdmin ? ()=>this.callbackCloseModal(false) : this.successSubmited;
                    switch(type){
                        case 'create':
                            this.create(successCallback,
                                (response)=>{
                                    Errors.showAlerts(response.errors);
                                }, 'POST'
                            );
                            break;
                        case 'edit':
                            this.update(successCallback,
                                (response)=>{
                                    Errors.showAlerts(response.errors);
                                }, 'POST'
                            );
                            break;
                    }
                }
            });
            this.initPrepareFilesListener(type, entityClass);
        }
    }

    successSubmited() {
        $('#help-confirmation-modal').modal('show');
        $('#create-help_ticket-modal').modal('hide');
    }

    initScreenShotListener() {
        if (!checkIfBrowserSupported())
        {
            console.log("Browser not support taking screenshots");
            $('#take_screenshot_ticket').css("display", "none");
            return;
        }

        $('#take_screenshot_ticket').off();
        $('#take_screenshot_ticket').on("click", function(e) {
            e.preventDefault();
            if (checkIfBrowserSupported()) {
                takeScreenshot({
                    quality: 1.0,
                    onCaptureStart: () => {
                        $(`#create-help_ticket-modal`).modal('hide');
                    },
                    onCaptureEnd: () => {
                        $(`#create-help_ticket-modal`).modal('show');
                    }
                })
                .then((screenshot) => {
                    $("#screenshot").val(screenshot);
                    $('#take_screenshot_ticket').css("display", "none");
                    $('#take_screenshot_ticket_attached').css("display", "block");
                });
             }

            return false;
        });
    }

    initPrepareFilesListener(type, entityClass){
        $(document).off('prepare_files').on('prepare_files', (e) => {
            const fileTemplate = document.querySelector('#modal-file-item')
            if(fileTemplate && e?.detail?.files){
                for(let file of e.detail.files){
                    const newPreview = fileTemplate.cloneNode(true)
                    $(newPreview).toggleClass(['d-none', 'd-flex']);
                    newPreview.removeAttribute('id')
                    const previewLink = newPreview.querySelector('.download-file-btn')
                    previewLink.href = URL.createObjectURL(file)
                    previewLink.download = file.upload.filename
                    const deleteLink = newPreview.querySelector('.delete-file-btn')
                    deleteLink.setAttribute('data-file-uuid', file.upload.uuid)
                    deleteLink.setAttribute('data-file-id','');
                    newPreview.setAttribute('data-uuid', file.upload.uuid)
                    newPreview.querySelector(`.file-img[data-file-type="${/^image\/.*/.test(file.type) ? 'img' : 'doc'}"]`).classList.remove('d-none')
                    newPreview.querySelector('.file-name').textContent = file.upload.filename
                    $(`#${type}-${entityClass} #files-container`).append(newPreview);
                }
            }
        });

        $('body').off('click', `#${type}-${entityClass} .delete-file-btn`)
        .on('click', `#${type}-${entityClass} .delete-file-btn`, (e)=>{
            const fileId = e.currentTarget.getAttribute('data-file-uuid')
            if(this.prepareFiles instanceof FormData){
                const result = Array.from(this.prepareFiles.entries()).filter(([key,file])=> file.upload.uuid!=fileId)
                this.prepareFiles = new FormData()
                result.forEach(([key,file])=>this.prepareFiles.append(key,file))
                $(`#${type}-${entityClass} [data-uuid="${fileId}"]`).remove()
            }
        })
    }

    validationForm(type, isSelectErrorFields=false){
        const formId = `${type}-${this.entityClass}`;

        const data = this.collectDataInForm(formId);
        const validator = new Validator({
            'subject': ['required'],
            'details': ['required']
        });

        let validate_flag = true;

        this.#validation_fields.forEach(element => {
            if (validator.validate(element, data.get(element))) {
                if(isSelectErrorFields)
                    $('#'+formId+' [name="'+element+'"]').removeClass('border-danger').css('border','');
            }else{
                validate_flag = false;
                if(isSelectErrorFields)
                    $('#'+formId+' [name="'+element+'"]').addClass('border-danger').css('border','2px solid');
            }
        });

        return validate_flag;
    }

    autocompleteForm(subject, details){
        $('#create-help_ticket-modal').find('#subjectTicket').val(subject);
        $('#create-help_ticket-modal').find('#detailsTicket').text(details).trigger('input');
    }

    stringify(obj) {
        let cache = [];
        let str = JSON.stringify(obj, function(key, value) {
            let push = true;
            if (typeof value === "object" && value !== null) {
                if (cache.indexOf(value) !== -1) {
                // Circular reference found, discard key
                return;
                }
                // Store value in our collection

                if (typeof value.value !== 'undefined' && value.value !== null && typeof value.value == 'object') {
                    value.value.forEach(element => {
                        if (element!==null && element!=='undefined' && typeof element.__livewire !== 'undefined') {
                            push= false;
                        }
                    });
                }
                cache.push(value);
            }
            if (push) {
                return value;
            }else{
                return 'html elem';
            }
        });
        console.log(str);
        cache = null; // reset the cache
        return str;
    }
}
